<div class="global-search-input-container">
    <input #input
        (input)="onInputChange($event.target.value)"
        [autofocus]="true"
        [value]="value"
        class="global-search-input"
        id="search-input"
        maxlength="255"
        nInput
        placeholder="{{ i18n.placeholder }}"
        type="text" />
    <span (click)="clear()"
        (mousedown)="$event.preventDefault()"
        *ngIf="value"
        class="global-search-input-clear">
        <svg class="icon">
            <use xlink:href="#icon-close"></use>
        </svg>
    </span>
    <svg (click)="expand()" *ngIf="!showAnimate && hasExpandPermission()"
        [nTooltip]="i18n.advancedSearchTip"
        class="icon expand">
        <use xlink:href="#infigo-expand"></use>
    </svg>
    <img (click)="expand()"
        *ngIf="showAnimate && hasExpandPermission()"
        [nTooltip]="i18n.advancedSearchTip" alt=""
        class="icon expand" src="/assets/images/AdvanceQuery.svg" style="width: 0.22rem;height: 0.22rem;top:0.14rem">
</div>
